module.exports = __webpack_public_path__ + "static/media/horizontal-white-text.acbd4f8f.svg";